module.exports = __webpack_public_path__ + "img/Qualification_2.1042291d.jpg";